import styled from 'styled-components'

export const CreateEntityDrawerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  height: 100%;
  width: 400px;

  & button {
    width: 100%;
  }
`

export const DrawerNavWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 25px;
  left: 20px;
`
export const DrawerHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;

  padding: 20px;
`
export const BackButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  & button {
    display: flex;
    align-items: center;
    gap: 10px;

    max-height: 20px;
    font-size: 15px;
    text-align: left;
    border: none !important;
    padding: 0 !important;
    background-color: transparent !important;
    color: ${({ theme }) => theme.colors.primary} !important;
  }
  & button:hover {
    color: ${({ theme }) => theme.colors.brand} !important;
    & svg > path {
      stroke: ${({ theme }) => theme.colors.brand} !important;
    }
  }
`

export const DrawerContent = styled.div`
  flex: 1;

  overflow-y: auto;

  width: 100%;
  padding: 20px;
`

export const DrawerFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  width: 100%;
  padding: 20px;

  border-top: 1px solid ${({ theme }) => theme.colors.backgroundLite};

  & button {
    width: ${({ formPage }) => (formPage === 5 ? '100%' : 'auto')};
  }
`

export const DrawerCloseIcon = styled.div`
  display: flex;
  justify-content: flex-end;
  cursor: pointer;

  // TODO: Use Theme Functions
  &:hover {
    opacity: 0.7;
  }
  & svg {
    fill: ${({ theme }) => theme.colors.primary};
  }
  & svg > path {
    fill: ${({ theme }) => theme.colors.primary};
  }
`

export const DrawerTitle = styled.div`
  margin: 0;

  font-size: 20px;
  font-weight: 500;
  text-align: center;

  // TODO: Use Theme Color
  color: ${({ theme }) => theme.colors.primary};
`
export const Divider = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${({ theme }) => theme.colors.backgroundLite};
  margin-top: 30px;
`
